/**
 * Um parágrafo de módulo de dados (faqDef, artigosDef) com os trechos entre `**` sublinhados.
 * Os módulos são `.js`, sem JSX, então a marcação mora no texto e o parse mora aqui — um só, para
 * a FAQ e a Central de ajuda não divergirem na regra de destaque.
 */
export default function TextoComDestaque({ texto }) {
  return texto.split(/(\*\*[^*]+\*\*)/).map((trecho, indice) =>
    trecho.startsWith('**') && trecho.endsWith('**') ? (
      <span key={indice} className="underline underline-offset-2">
        {trecho.slice(2, -2)}
      </span>
    ) : (
      trecho
    ),
  );
}
